import { useEffect, useState } from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router'
import { getConnection } from './services/salesforce'
import LoginPage from './pages/LoginPage'
import CallbackPage from './pages/CallbackPage'
import EditorPage from './pages/EditorPage'
import PreviewPage from './pages/PreviewPage'
import LogoutPage from './pages/LogoutPage'
import NotFoundPage from './pages/NotFoundPage'
import SettingsPage from './pages/SettingsPage'

const theme = createTheme({
  palette: {
    primary: {
      main: '#5985a9',
    },
    secondary: {
      main: '#764ba2',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
})

// 未認証時にcareerIdをlocalStorageに保存してからログイン画面にリダイレクトするコンポーネント
function SaveCareerIdAndRedirect() {
  const { careerId } = useParams()

  // careerIdをlocalStorageに保存（認証前でも保存）
  if (careerId) {
    localStorage.setItem('sf_career_id', careerId)
  }

  return <Navigate to="/login" />
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null)

  useEffect(() => {
    // 認証状態チェック
    const conn = getConnection()
    setIsAuthenticated(!!conn)
  }, [])

  if (isAuthenticated === null) {
    return <div>Loading...</div>
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/callback" element={<CallbackPage onAuthenticated={() => setIsAuthenticated(true)} />} />
          <Route path="/logout" element={<LogoutPage />} />
          <Route path="/settings" element={isAuthenticated ? <SettingsPage /> : <Navigate to="/login" />} />
          <Route
            path="/editor"
            element={
              isAuthenticated ? (
                (() => {
                  const careerId = localStorage.getItem('sf_career_id')
                  return careerId ? <Navigate to={`/editor/${careerId}`} replace /> : <NotFoundPage />
                })()
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route path="/editor/:careerId" element={isAuthenticated ? <EditorPage /> : <SaveCareerIdAndRedirect />} />
          <Route
            path="/editor/:careerId/preview"
            element={isAuthenticated ? <PreviewPage /> : <Navigate to="/login" />}
          />
          <Route
            path="*"
            element={
              <Navigate to={isAuthenticated ? `/editor/${localStorage.getItem('sf_career_id') || ''}` : '/login'} />
            }
          />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
